import appsClinicianStaffPGRC from './dashboard-staff-pgrc'

export default [...appsClinicianStaffPGRC]